// ⚠️ INTENTIONALLY VULNERABLE - For scanner testing only!
// These are FAKE credentials - do not use in production

export const API_KEY = "sk-proj-abc123def456ghi789jkl012mno345pqr678stu901vwx234";
export const AWS_SECRET_ACCESS_KEY = "wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY";
export const AWS_ACCESS_KEY_ID = "AKIAIOSFODNN7EXAMPLE";
export const STRIPE_SECRET_KEY = "sk_live_51HG3j2CjOEJRPOHnBkZV9HuOFKOYI2GePY";
export const DATABASE_URL = "postgresql://admin:SuperSecret123!@db.example.com:5432/production";
export const GITHUB_TOKEN = "ghp_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdef12";
export const JWT_SECRET = "my-super-secret-jwt-key-dont-share-this-2024";
export const SENDGRID_API_KEY = "SG.abcdefghijklmnop.qrstuvwxyz1234567890ABCDEFGHIJKLMNOP";
export const OPENAI_API_KEY = "sk-abc123def456ghi789jkl012mno345pqr678stu901vwx";
export const FIREBASE_API_KEY = "AIzaSyDOCAbC123dEf456GhI789jKl012-MnO";

// Hardcoded password (another vulnerability pattern)
export const ADMIN_PASSWORD = "admin123!";
export const DB_PASSWORD = "p@ssw0rd_pr0d_2024";

// Private key material
export const PRIVATE_KEY = `-----BEGIN RSA PRIVATE KEY-----
MIIEowIBAAKCAQEA2a2rwplBQLHgMr1q3EXAMPLE
-----END RSA PRIVATE KEY-----`;

// ⚠️ Intentional: exposed cloud storage bucket URLs
export const S3_BUCKET_URL = "https://my-app-uploads.s3.amazonaws.com";
export const S3_BACKUP_BUCKET = "https://s3.eu-west-1.amazonaws.com/company-backups-prod";
export const GCS_BUCKET_URL = "https://storage.googleapis.com/my-app-user-data";
export const AZURE_BLOB_URL = "https://mycompanystorage.blob.core.windows.net/uploads";
export const SUPABASE_STORAGE_URL = "https://abcdefghijklmnop.supabase.co/storage/v1/object/public/avatars";
export const FIREBASE_STORAGE_URL = "https://firebasestorage.googleapis.com/v0/b/my-app-prod.appspot.com/o";
